module.exports = __webpack_public_path__ + "img/plexlogo.a33a4eda.png";